import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { withApollo } from "react-apollo";
import React from "react";
import { fetchGenericMasterByIdQuery } from "../../../services/graphql/queries/masters";
import queryString from "query-string";
import GenericMasterView from "./GenericMasterView";
import GenericMasterEdit from "./GenericMasterEdit";
import { getAccessPermisionQuery } from "../../../services/graphql/queries/accessPermission";
class GenericMasterProfile extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      editMode: false,
      loading: false,
      error: "",
      genericMaster: [],
      isCreated: false,
      genericMasterData: {},
      genericMastervalue: false,
      GenericMaster_Feature_ID: 170,
      GenericMaster_Module_ID: 6,
      accessSpecifier: {}
    };
    this.onUpdateGenericMaster = this.onUpdateGenericMaster.bind(this);
    this.toggleEditMode = this.toggleEditMode.bind(this);
    this.getGenericMaster = this.getGenericMaster.bind(this);
  }

  toggleEditMode(mode) {
    this.setState({ editMode: mode });
  }
  onUpdateGenericMaster() {
    this.getGenericMaster();
  }
  getGenericMaster() {
    this.props.client
      .query({
        query: fetchGenericMasterByIdQuery,
        variables: {
          id: parseInt(queryString.parse(this.props.location.search).id)
        },
        fetchPolicy: "network-only"
      })
      .then(result => {
        let genericMaster = JSON.parse(result.data.fetchGenericMasterById);
        this.setState({
          genericMaster: genericMaster,
          genericMastervalue: true,
          loading: false
        });
      })
      .catch(error => {
        this.setState({ loading: false, error: error.message });
      });
  }
  fetchAccessSpecifier() {
    this.setState({
      loading: true
    });
    this.props.client
      .query({
        query: getAccessPermisionQuery,
        variables: {
          moduleId: this.state.GenericMaster_Module_ID
        },
        fetchPolicy: "network-only"
      })
      .then(result => {
        let response = result.data.getFunctionByModuleId;
        response = JSON.parse(response);
        if (Object.keys(response).length != 0) {
          this.setState({
            accessSpecifier: response[this.state.GenericMaster_Feature_ID]
          });
          this.getGenericMaster();
        }
      })
      .catch(error => {
        this.setState({
          loading: false,
          error: error.message
        });
      });
  }
  componentDidMount() {
    this.fetchAccessSpecifier();
  }
  render() {
    const {
      loading,
      error,
      genericMaster,
      isCreated,
      accessSpecifier
    } = this.state;

    if (error) return <div>Error !!!</div>;
    if (loading) return <div>Fetching...</div>;
    return (
      <>
        {this.state.genericMaster != "" &&
        Object.keys(this.state.accessSpecifier).length ? (
          <>
            {this.state.editMode ? (
              <GenericMasterEdit
                genericMaster={genericMaster}
                toggleEditMode={this.toggleEditMode}
                onUpdateGenericMaster={this.onUpdateGenericMaster}
              />
            ) : (
              <GenericMasterView
                genericMaster={genericMaster}
                toggleEditMode={this.toggleEditMode}
                // isCreated={isCreated}
                genericMasterData={this.state.genericMasterData}
                accessSpecifier={accessSpecifier}
              />
            )}
          </>
        ) : (
          <div>Fetching...</div>
        )}
      </>
    );
  }
}

GenericMasterProfile.getInitialProps = ({ router }) => {
  return { router };
};

export default withRouter(connect()(withApollo(GenericMasterProfile)));
